import {
  CogIcon,
  CurrencyDollar,
  MagnifyingGlassIcon,
  ChatBubbleIcon,
  UserGroupIcon
} from '@/components/Icons';
import { AccountTypeEnum } from '@/context/types/Account';
import { Feature } from '@/config/featureFlags.definition';
import { routes } from '@/utils/routes';
import { sideNav } from '@/utils/translations';
import { NavItemIdEnum, TNavSectionConfig } from '@/versions/v3/types/SideNav';

export const SIDE_NAV_SECTIONS: TNavSectionConfig[] = [
  {
    id: NavItemIdEnum.MANAGE,
    label: sideNav.manage,
    items: [
      {
        id: NavItemIdEnum.PAYMENTS,
        icon: CurrencyDollar,
        label: sideNav.payments,
        route: routes.managePayment,
        requiredFeature: Feature.MANAGE_PAYMENT
      },
      {
        id: NavItemIdEnum.TEAM_MEMBERS,
        icon: UserGroupIcon,
        label: sideNav.teamMembers,
        route: routes.teamMembers,
        requiredAccountType: AccountTypeEnum.BUSINESS,
        requiredFeature: Feature.TEAM_MEMBERS
      },
      {
        id: NavItemIdEnum.SETTINGS,
        icon: CogIcon,
        label: sideNav.settings,
        requiredAccountType: AccountTypeEnum.BUSINESS,
        subItems: [
          {
            id: NavItemIdEnum.GL_SETTINGS,
            label: sideNav.generalLedgerSettings,
            route: routes.generalLedgerSettings
          },
          {
            id: NavItemIdEnum.XERO,
            label: sideNav.xeroConnections,
            actionKey: 'xero-modal'
          }
        ]
      }
    ]
  },
  {
    id: NavItemIdEnum.HELP,
    label: sideNav.help,
    items: [
      {
        id: NavItemIdEnum.FIND_ANSWERS,
        icon: MagnifyingGlassIcon,
        label: sideNav.findAnswers
      },
      {
        id: NavItemIdEnum.TALK_TEAMS,
        icon: ChatBubbleIcon,
        label: sideNav.talkToTeams
      }
    ]
  }
];
